module.exports = __webpack_public_path__ + "static/party-4cab2c16b10bf23120e54a3ff6ec74c7.mp4";